// Function to format the zip code
export const formatZipCode = (zip: string) => {
    if (!zip) return '';
    // Remove any non-digit characters
    const digits = zip.replace(/\D/g, '');
    
    // Format to #####-####
    if (digits.length <= 5) {
      return digits; // Return just the 5 digits
    } else {
      return `${digits.slice(0, 5)}-${digits.slice(5, 9)}`; // Format to "#####-####"
    }
  }